export default {
  computed: {
    isProjectPendingRemoval() {
      return false;
    },
  },
};
